export default {
  APPLE: 'CRDNC_AAPL',
  GOOGLE: 'CRDNC_GOOG',
};
